// Normalize brand name to match react-credit-cards expected values
const normalizeBrandName = (brandName) => {
  if (!brandName) return '';
  const normalized = brandName.toLowerCase().trim();
  // Map common brand name variations to react-credit-cards expected values
  if (normalized.includes('visa')) return 'visa';
  if (normalized.includes('mastercard') || normalized.includes('master')) return 'mastercard';
  if (normalized.includes('amex') || normalized.includes('american express')) return 'amex';
  if (normalized.includes('discover')) return 'discover';
  if (normalized.includes('diners')) return 'dinersclub';
  if (normalized.includes('jcb')) return 'jcb';
  if (normalized.includes('unionpay')) return 'unionpay';
  if (normalized.includes('maestro')) return 'maestro';
  if (normalized.includes('elo')) return 'elo';
  if (normalized.includes('hipercard')) return 'hipercard';
  if (normalized.includes('hiper')) return 'hiper';
  return normalized;
};

export default normalizeBrandName;
